import Vue from 'vue'
import NProgress from 'nprogress';
import Router from 'vue-router'
import auth from '@/utils/auth'
import login from '@/components/login'
import pickuplocation from '@/components/pickuplocation'
import pickuplocation_mr from '@/components/pickuplocation_mr'

import adminuser_mr from '@/components/adminuser_mr'
import rack from '@/components/rack'

import printsticker from '@/components/printsticker'
//import thirdpartyshipment from '@/components/thirdpartyshipment'
import dashboard_adv from '@/components/dashboard_adv'


import hubtohub from '@/components/hubtohub'
import userwisefinince_dashboard from '@/components/userwisefinince_dashboard'
import riderwisefinince_dashboard from '@/components/riderwisefinince_dashboard'
import statusreport_adv from '@/components/statusreport_adv'
import runsheet from '@/components/runsheet'
import payroll_report from '@/components/payroll_report'
import fcclock_weeklyupload from '@/components/fcclock_weeklyupload'


import adddeliveryagent from '@/components/adddeliveryagent'
//import firstmileridermapping from '@/components/firstmileridermapping'
//import vendorcodes from '@/components/vendorcodes'
import rtsReport from '@/components/rtsReport'




//import bulkupload from '@/components/bulkupload'

import deliveryagentmaster_mr from '@/components/deliveryagentmaster_mr'

import reallocationpickup from '@/components/reallocationpickup'

import consignmenttracking_mr from '@/components/consignmenttracking_mr'
// import dashboard from '@/components/dashboard'
// import dashboard_mr from '@/components/dashboard_mr'

//import home from '@/components/home'
import rtoHandover from '@/components/rtohandover'

// import shipmentlocationtrack from '@/components/shipmentlocationtrack'

import MarkPickupCancel from '@/components/markpickupcancel'


//import pickupstatusmaster from '@/components/pickupstatusmaster'
import misreport1 from '@/components/misreport1'
import misreport_adv from '@/components/misreport_adv'
import misreport_me from '@/components/misreport_me'
import misreportfinance from '@/components/misreportfinance'
import mobilelogging from '@/components/mobilelogging'
import picknotassignedShipments from '@/components/picknotassignedShipments'


import markBatchCancel from '@/components/markBatchCancel'
import reattemptshipments from '@/components/reattemptshipments'
import previousmisreport from '@/components/previousmisreport'
import undeliveredshipmentstatus from '@/components/undeliveredshipmentstatus'





import CONSTANTS from '@/utils/constants'
import receiptTracker from '@/components/receiptTracker'
//import markdeliverystatus from '@/components/markdeliverystatus'
import updatepincodeagainshipmentid from '@/components/updatepincodeagainshipmentid'
import removeshipment from '@/components/removeshipment'
import misreport from '@/components/misreport'
import bulkallocation from '@/components/bulkallocation'
import shipmentreport from '@/components/shipmentreport'
import dashboardAwblist from '@/components/dashboardAwblist'
import awbShipmentlist from '@/components/awbShipmentlist'
import warrentyshipmentreport from '@/components/warrentyshipmentreport'
import InScanrack from '@/components/InScanrack'
import ndrscanrack from '@/components/ndrscanrack'
import pushcustomlog from '@/components/pushcustomlog'
import pushlogisticstatus from '@/components/pushlogisticstatus'
import zonemaster from '@/components/zonemaster'
import pincodes from '@/components/pincodes'

import vendorcodes from '@/components/vendorcodes'
import reallocatepallet from '@/components/reallocatepallet'
import palletinfo1 from '@/components/palletinfo1'
import managePallets from '@/components/managePallets'
import zonenames from '@/components/zonenames'
import Vendorrejectlist from '@/components/Vendorrejectlist'
import master_awb from '@/components/master_awb'
import LineHaulPalletlisting from '@/components/LineHaulPalletlisting'
import masterawblisting from '@/components/masterawblisting'
import mezonemanagement from '@/components/mezonemanagement'
import masterawbdetails from '@/components/masterawbdetails'
import shipment_masterawb from '@/components/shipment_masterawb'
import bulkshipment from '@/components/bulkshipment'


import rvpallocation from '@/components/rvpallocation'
import markdelivery from '@/components/markdelivery'
import requestdelivery from '@/components/requestdelivery'
import pod_proof from '@/components/pod_proof'


import me_skyexpress from '@/components/me_skyexpress'
import skyex_shipment_tracking from '@/components/skyex_shipment_tracking'
import riderwiseofd from '@/components/riderwiseofd'
import riderwise_productdetails from '@/components/riderwise_productdetails'
import addvehicleInfo from '@/components/addvehicleInfo'
import vehicleMaster from '@/components/vehicleMaster'
import planUpload from '@/components/planUpload'
import viewPlanDetails from '@/components/viewPlanDetails'
import allocateloadManagement from '@/components/allocateloadManagement'
import access from '@/components/access'
import deliverystatusreport_mr from '@/components/deliverystatusreport_mr'
import bulkreallocation from '@/components/bulkreallocation'
import mark_bookingdoneDelivery from '@/components/mark_bookingdoneDelivery'
import vehicle_start_end_trip from '@/components/vehicle_start_end_trip'
import Misreport_mpswise from '@/components/Misreport_mpswise'
import Misreport_loadwise from '@/components/Misreport_loadwise'
import Misreport_loadwise_modified from '@/components/Misreport_loadwise_modified'
import adhocAllocation from '@/components/adhocAllocation'
import adhocVehicle from '@/components/adhocVehicle'
import coordinator_user from '@/components/coordinator_user'
import daily_trip from '@/components/daily_trip'
import daily_trip_new from '@/components/daily_trip_new'

import trip_history from '@/components/trip_history'
import hub_management from '@/components/hub_management'
import hub_details from '@/components/hub_details'
import hub_details_list from '@/components/hub_details_list'
import gate_pass from '@/components/gate_pass'
import gate_exit_pass from '@/components/gate_exit_pass'
import gate_entry_pass from '@/components/gate_entry_pass'

//shamal start
import route_management from '@/components/route_management'
import zone_management from '@/components/zone_management'
import ENB_extension from '@/components/ENB_extension'
import hubinscanoutscan from '@/components/hubin_outscan_details'
import hubinscanoutscan_details from '@/components/hubinscanoutscan_details'
import newzone_management from '@/components/new_zone_management'
import incident_master from '@/components/incident_master'
import open_incident from '@/components/open_incident'
import open_approve_incident from '@/components/open_approve_incident'
import incident_listing from '@/components/incident_listing'
import report_incident from '@/components/report_incident'
import approve_incident from '@/components/approve_incident'
import rejected_incident from '@/components/rejected_incident'
import other_incident from '@/components/other_incident'
import vendor_zone_management from '@/components/vendor_zone_management'
import intransit_report from '@/components/intransit_report'
import damage_shortage from '@/components/damage_shortage'
import deliverydashboard from '@/components/deliverydashboard'
import route_mappingDetails from '@/components/route_mappingDetails'

import DestinationMaster from '@/components/RB_destination_master'
import DestinationGroupMaster from '@/components/RB_destinationgroup_master'
import OriginMaster from '@/components/RB_origin_master'
import origingroup_master from '@/components/RB_origingroup_master'
import constraintMaster from '@/components/RB_constraint_master'
import Zone_master from '@/components/RB_zone_master'
import pickupdone from '@/components/pickupdone'
//shamal end
import route_mapping from '@/components/route_mapping'
import plan_master from '@/components/plan_master'
import direct_dispatch from '@/components/direct_dispatch'
import handover_pendency from '@/components/WH_HandoverPendency'
// import shipment_tracking from '@/components/shipment_tracking'
import vehicle_tracking from '@/components/vehicle_tracking'
import testData from '@/components/testData'
import transporter_master from '@/components/transporter_master'
import PDA_Management from '@/components/PDA_Management'
import PDA_Add from '@/components/PDA_Add'
import route_history from '@/components/route_history'
import route_configuration from '@/components/route_configuration'
import vehicle_reallocation from '@/components/vehicle_reallocation'
import Daily_pickup_report from '@/components/Daily_pickup_report'
import tatreport from '@/components/tatreport'
import tatUpload from '@/components/tatUpload'
import fcclock_Dashboard from '@/components/fcclock_Dashboard'
import employeerequest from '@/components/employeerequest'
import fcclock_datatable from '@/components/fcclock_datatable'
// import payroll_report from '@/components/payroll_report'
// import fcclock_weeklyupload from '@/components/fcclock_weeklyupload'
import fcclock_hubconfiguration_details from '@/components/fcclock_hubconfiguration_details'
import pdamoduleaccess from '@/components/pdamoduleaccess'
import serviceable_pincode from '@/components/serviceable_pincode'
import approver_config from '@/components/approver_config'
import EDD_report from '@/components/EDD_report'
import request_config from '@/components/request_config'

import vehicle_tracking_new from '@/components/vehicle_tracking_new'
import vehicleMasterNew from '@/components/vehicleMasterNew'
import addvehicleInfoNew from '@/components/addvehicleInfoNew'
import newplanlisting from '@/components/newPlanListing'
import newplanupload from '@/components/newPlanUpload'
import nlh_dashboard from '@/components/nlh_dashboard'

// Ajay code
import raisedRequest from '@/components/adhocVehicleRequisitionSystem/raisedRequestTab1/raisedRequest.vue';
import adhocVehicleFreight from '@/components/adhocVehicleRequisitionSystem/raisedRequestTab1/adhocVehicleFreight.vue';
import adhocVehicleFreightApproval from '@/components/adhocVehicleRequisitionSystem/raisedRequestTab1/adhocVehicleFreightApproval.vue';
import addNewVehicleDetails from '@/components/adhocVehicleRequisitionSystem/raisedRequestTab1/addNewVehicleDetails.vue';

import availableVehicleList from '@/components/availableVehicleList'

import notificationStatus from '@/components/notificationStatus/notificationStatus'

// audit route
import AuditStatusDetails from '@/components/audit/audit_status_details'
import AuditStatusDashboard from '@/components/audit/audit_status_dashboard'

// fc clock regularization
import FcClockRegularization from '@/components/fcClockAttendance/regularization'
import fcClockEmployeeRequests from '@/components/fcClockAttendance/fcclockemployeerequests'

import newplanuploadNew from '@/components/newPlanUploadNew'
import apkUrlUpload from '@/components/apkUrlUpload'
import PickDoneToOFD from '@/components/PickDoneToOFD'
import operational_dashboard from '@/components/operational_dashboard'
import vehiclemovement  from '@/components/vehiclemovement'
import shipmentsdispatched from '@/components//shipmentsdispatched'
import srid from '@/components/srid'
import shipment_tracking from '@/components/shipment_tracking_new'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')
// Views
//const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/Charts')
const Widgets = () => import('@/views/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const Flags = () => import('@/views/icons/Flags')
const FontAwesome = () => import('@/views/icons/FontAwesome')
const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

Vue.use(Router)

const router = new Router({
  base: process.env.VUE_APP_PUBLIC_URL,
  mode: 'history', // https://router.vuejs.org/api/#mode hash
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [{
    path: '/',
    component: DefaultContainer,
    redirect: '/login',
    children: [
      {
      path: '/dashboard_adv',
      name: 'dashboard_adv_default',
      component: dashboard_adv,
      beforeEnter: requireAuth
    },
    {
      path: '/dashboard_adv/:id',
      name: 'dashboard_adv',
      component: dashboard_adv,
      beforeEnter: requireAuth
    },

      {
        path: '/bulkallocation',
        name: 'Bulk Allocation',
        component: bulkallocation,
        beforeEnter: requireAuth
      },
      {
        path: '/pickuplocation',
        name: 'pickuplocation',
        component: pickuplocation,
        beforeEnter: requireAuth
      },
      {
        path: '/pickuplocation_mr',
        name: 'pickuplocation_mr',
        component: pickuplocation_mr,
        beforeEnter: requireAuth
      },
      {
        path: '/pushcustomlog',
        name: 'pushcustomlog',
        component: pushcustomlog,
        beforeEnter: requireAuth
      },
      {
        path: '/pushlogisticstatus',
        name: 'pushlogisticstatus',
        component: pushlogisticstatus,
        beforeEnter: requireAuth
      },
      {
        path: '/shipmentreport/:id',
        name: 'shipmentreport',
        component: shipmentreport,
        beforeEnter: requireAuth
      },
      {
        path: '/dashboardAwblist/:id',
        name: 'dashboardAwblist',
        component: dashboardAwblist,
        beforeEnter: requireAuth
      },
      {
        path: '/awbShipmentlist/:id',
        name: 'awbShipmentlist',
        component: awbShipmentlist,
        beforeEnter: requireAuth
      },
      {
        path: '/warrentyshipmentreport/:id',
        name: 'warrentyshipmentreport',
        component: warrentyshipmentreport,
        beforeEnter: requireAuth
      },

      {
        path: '/adminuser_mr',
        name: 'adminuser_mr',
        component: adminuser_mr,
        beforeEnter: requireAuth
      },

      {
        path: '/receiptTracker',
        name: 'receiptTracker',
        component: receiptTracker,
        beforeEnter: requireAuth
      },

      {
        path: '/rack',
        name: '/rack',
        component: rack,
        beforeEnter: requireAuth
      },

      {
        path: '/printsticker',
        name: '/printsticker',
        component: printsticker,
        beforeEnter: requireAuth
      },
      {
        path: '/runsheet',
        name: '/runsheet',
        component: runsheet,
        beforeEnter: requireAuth
      },

      {
        path: '/hubtohub',
        name: '/hubtohub',
        component: hubtohub,
        beforeEnter: requireAuth
      },
      {
        path: '/deliveryagentmaster_mr',
        name: 'deliveryagentmaster_mr',
        component: deliveryagentmaster_mr,
        beforeEnter: requireAuth
      },
      {
        path: '/adddeliveryagent',
        name: 'Add',
        component: adddeliveryagent,
        beforeEnter: requireAuth
      },
      {
        path: '/consignmenttracking_mr/:id',
        name: 'consignmenttracking_mr',
        component: consignmenttracking_mr,
        beforeEnter: requireAuth
      },
      {
        path: '/rtoHandover',
        name: 'rtoHandover',
        component: rtoHandover,
        beforeEnter: requireAuth
      },
      {
        path: '/MarkPickupCancel',
        name: 'MarkPickupCancel',
        component: MarkPickupCancel,
        beforeEnter: requireAuth
      },

      {
        path: '/previousmisreport',
        name: 'previousmisreport',
        component: previousmisreport,
        beforeEnter: requireAuth
      },

      {
        path: '/misreport1',
        name: 'misreport1',
        component: misreport1,
        beforeEnter: requireAuth
      },
      {
        path: '/misreport_adv',
        name: 'misreport_adv',
        component: misreport_adv,
        beforeEnter: requireAuth
      },
      {
        path: '/misreport_me',
        name: 'misreport_me',
        component: misreport_me,
        beforeEnter: requireAuth
      },

      {
        path: '/misreport',
        name: 'misreport',
        component: misreport,
        beforeEnter: requireAuth
      },

      {
        path: '/userwisefinince_dashboard',
        name: 'userwisefinince_dashboard',
        component: userwisefinince_dashboard,
        beforeEnter: requireAuth
      },
      {
        path: '/riderwisefinince_dashboard',
        name: 'riderwisefinince_dashboard',
        component: riderwisefinince_dashboard,
        beforeEnter: requireAuth
      },

      {
        path: '/misreportfinance',
        name: 'misreportfinance',
        component: misreportfinance,
        beforeEnter: requireAuth
      },

      {
        path: '/mobilelogging',
        name: 'mobilelogging',
        component: mobilelogging,
        beforeEnter: requireAuth
      },
      {
        path: '/picknotassignedShipments',
        name: 'picknotassignedShipments',
        component: picknotassignedShipments,
        beforeEnter: requireAuth
      },
      {
        path: '/reallocationpickup',
        name: 'reallocationpickup',
        component: reallocationpickup,
        beforeEnter: requireAuth
      },

      {
        path: '/rtsReport',
        name: 'rtsReport',
        component: rtsReport,
        beforeEnter: requireAuth
      },

      {
        path: '/reattemptshipments',
        name: 'reattemptshipments',
        component: reattemptshipments,
        beforeEnter: requireAuth
      },


      {
        path: '/markBatchCancel',
        name: 'markBatchCancel',
        component: markBatchCancel,
        beforeEnter: requireAuth
      },
      {
        path: '/undeliveredshipmentstatus',
        name: 'undeliveredshipmentstatus',
        component: undeliveredshipmentstatus,
        beforeEnter: requireAuth
      },
      {
        path: '/updatepincodeagainshipmentid',
        name: 'updatepincodeagainshipmentid',
        component: updatepincodeagainshipmentid,
        beforeEnter: requireAuth
      },
      {
        path: '/statusreport_adv',
        name: 'statusreport_adv',
        component: statusreport_adv,
        beforeEnter: requireAuth
      },

      {
        path: '/removeshipment',
        name: 'removeshipment',
        component: removeshipment,
        beforeEnter: requireAuth
      },
      {
        path: '/InScanrack',
        name: 'InScanrack',
        component: InScanrack,
        beforeEnter: requireAuth
      },
      {
        path: '/ndrscanrack',
        name: 'ndrscanrack',
        component: ndrscanrack,
        beforeEnter: requireAuth
      },
      {
        path: '/zonemaster',
        name: 'zonemaster',
        component: zonemaster,
        beforeEnter: requireAuth
      },
      {
        path: '/pincodes',
        name: 'pincodes',
        component: pincodes,
        beforeEnter: requireAuth
      },

      {
        path: '/vendorcodes',
        name: 'vendorcodes',
        component: vendorcodes,
        beforeEnter: requireAuth
      },
      {
        path: '/reallocatepallet',
        name: 'reallocatepallet',
        component: reallocatepallet,
        beforeEnter: requireAuth
      },
      {
        path: '/palletinfo1',
        name: 'palletinfo1',
        component: palletinfo1,
        beforeEnter: requireAuth
      },
      {
        path: '/managePallets',
        name: 'managePallets',
        component: managePallets,
        beforeEnter: requireAuth
      },
      {
        path: '/zonenames',
        name: 'zonenames',
        component: zonenames,
        beforeEnter: requireAuth
      },
      {
        path: '/Vendorrejectlist',
        name: 'Vendorrejectlist',
        component: Vendorrejectlist,
        beforeEnter: requireAuth
      },
      {
        path: '/master_awb',
        name: 'master_awb',
        component: master_awb,
        beforeEnter: requireAuth
      },
      {
        path: '/LineHaulPalletlisting',
        name: 'LineHaulPalletlisting',
        component: LineHaulPalletlisting,
        beforeEnter: requireAuth
      },
      {
        path: '/masterawblisting/:id?',
        name: 'masterawblisting',
        component: masterawblisting,
        beforeEnter: requireAuth
      },
      {
        path: '/masterawbdetails',
        name: 'masterawbdetails',
        component: masterawbdetails,
        beforeEnter: requireAuth
      },
      {
        path: '/shipment_masterawb',
        name: 'shipment_masterawb',
        component: shipment_masterawb,
        beforeEnter: requireAuth
      },
      {
        path: '/mezonemanagement',
        name: 'mezonemanagement',
        component: mezonemanagement,
        beforeEnter: requireAuth
      },
      {
        path: '/bulkshipment',
        name: 'bulkshipment',
        component: bulkshipment,
        beforeEnter: requireAuth
      },
      {
        path: '/rvpallocation',
        name: 'rvpallocation',
        component: rvpallocation,
        beforeEnter: requireAuth
      },
      {
        path: '/markdelivery',
        name: 'markdelivery',
        component: markdelivery,
        beforeEnter: requireAuth
      },
      {
        path: '/requestdelivery',
        name: 'requestdelivery',
        component: requestdelivery,
        beforeEnter: requireAuth
      },
      {
        path: '/pod_proof',
        name: 'pod_proof',
        component: pod_proof,
        beforeEnter: requireAuth
      },
      {
        path: '/me_skyexpress',
        name: 'me_skyexpress',
        component: me_skyexpress,
        beforeEnter: requireAuth
      },
      {
        path: '/skyex_shipment_tracking',
        name: 'skyex_shipment_tracking',
        component: skyex_shipment_tracking,
        beforeEnter: requireAuth
      },
      {
        path: '/riderwiseofd',
        name: 'riderwiseofd',
        component: riderwiseofd,
        beforeEnter: requireAuth
      },
      {
        path: '/riderwise_productdetails',
        name: 'riderwise_productdetails',
        component: riderwise_productdetails,
        beforeEnter: requireAuth
      },
      {
        path: '/addvehicleInfo',
        name: 'addvehicleInfo',
        component: addvehicleInfo,
        beforeEnter: requireAuth
      },

      {
        path: '/vehicleMaster',
        name: 'vehicleMaster',
        component: vehicleMaster,
        beforeEnter: requireAuth
      },
      {
        path: '/vehicleMasterNew',
        name: 'vehicleMasterNew',
        component: vehicleMasterNew,
        beforeEnter: requireAuth
      },
      {
        path: '/addvehicleInfoNew',
        name: 'addvehicleInfoNew',
        component: addvehicleInfoNew,
        beforeEnter: requireAuth
      },
      {
        path: '/newPlanListing',
        name: 'newplanlisting',
        component: newplanlisting,
        beforeEnter: requireAuth
      },
      {
        path: '/newPlanUpload',
        name: 'newplanupload',
        component: newplanupload,
        beforeEnter: requireAuth
      },
      {
        path: '/nlh_dashboard',
        name: 'nlh dashboard',
        component: nlh_dashboard,
        beforeEnter: requireAuth
      },

      {
        path: '/planUpload',
        name: 'planUpload',
        component: planUpload,
        beforeEnter: requireAuth
      },
      {
        path: '/viewPlanDetails/:id/',
        name: 'viewPlanDetails',
        component: viewPlanDetails,
        beforeEnter: requireAuth

      },
      {
        path: '/access/:id/',
        name: 'access',
        component: access,
        beforeEnter: requireAuth
      },
      {
        path: '/allocateloadManagement/:id',
        name: 'allocateloadManagement',
        component: allocateloadManagement,
        beforeEnter: requireAuth
      },
      // {
      //   path: '/allocateloadManagement/:id',
      //   name: 'allocateloadManagement',
      //   component: allocateloadManagement,
      //   beforeEnter: requireAuth
      // },     
      {
        path: '/deliverystatusreport_mr',
        name: 'deliverystatusreport_mr',
        component: deliverystatusreport_mr,
        beforeEnter: requireAuth
      },
      {
        path: '/bulkreallocation',
        name: 'bulkreallocation',
        component: bulkreallocation,
        beforeEnter: requireAuth
      },
      {
        path: '/mark_bookingdoneDelivery',
        name: 'mark_bookingdoneDelivery',
        component: mark_bookingdoneDelivery,
        beforeEnter: requireAuth
      },
      {
        path: '/vehicle_start_end_trip',
        name: 'vehicle_start_end_trip',
        component: vehicle_start_end_trip,
        beforeEnter: requireAuth
      },
      {
        path: '/Misreport_mpswise',
        name: 'Misreport_mpswise',
        component: Misreport_mpswise,
        beforeEnter: requireAuth
      },
      {
        path: '/gate_entry_pass',
        name: 'gate_entry_pass',
        component: gate_entry_pass,
        beforeEnter: requireAuth
      },
      {
        path: '/gate_exit_pass',
        name: 'gate_exit_pass',
        component: gate_exit_pass,
        beforeEnter: requireAuth
      },
      {
        path: '/gate_pass',
        name: 'gate_pass',
        component: gate_pass,
        beforeEnter: requireAuth
      },
      {
        path: '/Misreport_loadwise',
        name: 'Misreport_loadwise',
        component: Misreport_loadwise,
        beforeEnter: requireAuth
      },
      // {
      //   path: '/Misreport_loadwise',
      //   redirect: { name: 'Misreport_loadwise_modified' },
      //   beforeEnter: requireAuth
      // },
      {
        path: '/Misreport_loadwise_modified',
        name: 'Misreport_loadwise_modified',
        component: Misreport_loadwise_modified,
        beforeEnter: requireAuth
      },
      
      {
        path: '/adhocAllocation',
        name: 'adhocAllocation',
        component: adhocAllocation,
        beforeEnter: requireAuth
      },
      {
        path: '/adhocVehicle',
        name: 'adhocVehicle',
        component: adhocVehicle,
        beforeEnter: requireAuth
      },
      {
        path: '/coordinator_user',
        name: 'coordinator_user',
        component: coordinator_user,
        beforeEnter: requireAuth
      },
      {
        path: '/daily_trip',
        name: 'daily_trip',
        component: daily_trip,
        beforeEnter: requireAuth
      },
      {
        path: '/daily_trip_new',
        name: 'daily_trip_new',
        component: daily_trip_new,
        beforeEnter: requireAuth
      },


      {
        path: '/trip_history',
        name: 'trip_history',
        component: trip_history,
        beforeEnter: requireAuth
      },
      {
        path: '/hub_management',
        name: 'hub_management',
        component: hub_management,
        beforeEnter: requireAuth
      },
      {
        path: '/hub_details/:id',
        name: 'hub_details',
        component: hub_details,
        beforeEnter: requireAuth
      },
      {
        path: '/hub_details_list/:id',
        name: 'hub_details_list',
        component: hub_details_list,
        beforeEnter: requireAuth
      },
      //shamal start
      {
        path: '/route_management',
        name: 'route_management',
        component: route_management,
        beforeEnter: requireAuth
      },
      {
        path: '/zone_management',
        name: 'zone_management',
        component: zone_management,
        beforeEnter: requireAuth
      },
      {
        path: '/ENB_extension/:id',
        name: 'ENB_extension',
        component: ENB_extension,
        beforeEnter: requireAuth
      },
      {
        path: '/hub_in_out_scan_details/:id',
        name: 'hub_inscan_outscan',
        component: hubinscanoutscan,
        beforeEnter: requireAuth
      },
      {
        path: '/hubinscanoutscan_details/:id',
        name: 'hubinscanoutscan_details',
        component: hubinscanoutscan_details,
        beforeEnter: requireAuth
      },
      {
        path: '/new_zone_management/:id',
        name: 'newzone_management',
        key: ':id',
        component: newzone_management,
        beforeEnter: requireAuth
      },
      // {
      //   path : '/new_zone_management/:id',
      //   name : 'newzone_management',
      //   component : newzone_management,
      //   beforeEnter: requireAuth
      // },

      {
        path: '/incident_master',
        name: 'incident_master',
        component: incident_master,
        beforeEnter: requireAuth
      },

      {
        path: '/open_incident',
        name: 'open_incident',
        component: open_incident,
        beforeEnter: requireAuth
      },

      {
        path: '/open_approve_incident/:id?',
        name: 'open_approve_incident',
        component: open_approve_incident,
        beforeEnter: requireAuth
      },

      {
        path: '/incident_listing',
        name: 'incident_listing',
        component: incident_listing,
        beforeEnter: requireAuth
      },
      {
        path: '/report_incident',
        name: 'report_incident',
        component: report_incident,
        beforeEnter: requireAuth
      },

      {
        path: '/approve_incident',
        name: 'approve_incident',
        component: approve_incident,
        beforeEnter: requireAuth
      },

      {
        path: '/rejected_incident',
        name: 'rejected_incident',
        component: rejected_incident,
        beforeEnter: requireAuth
      },

      {
        path: '/other_incident',
        name: 'other_incident',
        component: other_incident,
        beforeEnter: requireAuth
      },
      {
        path: '/vendor_zone_management',
        name: 'vendor_zone_management',
        component: vendor_zone_management,
        beforeEnter: requireAuth
      },
      {
        path: '/intransit_report',
        name: 'intransit_report',
        component: intransit_report,
        beforeEnter: requireAuth
      },
      {
        path: '/damage_shortage',
        name: 'damage_shortage',
        component: damage_shortage,
        beforeEnter: requireAuth
      },
      {
        path: '/deliverydashboard',
        name: 'deliverydashboard',
        component: deliverydashboard,
        beforeEnter: requireAuth
      },
      {
        path: '/route_mappingDetails',
        name: 'route_mappingDetails',
        component: route_mappingDetails,
        beforeEnter: requireAuth
      },
      {
        path: '/destinationMaster',
        name: 'DestinationMaster',
        component: DestinationMaster,
      },
      {
        path: '/destinationGroupMaster',
        name: 'DestinationGroupMaster',
        component: DestinationGroupMaster,

      },
      {
        path: '/originMaster',
        name: 'OriginMaster',
        component: OriginMaster
      },
      {
        path: '/origingroup_master',
        name: 'origingroup_master',
        component: origingroup_master
      },
      {
        path: '/constraintMaster',
        name: 'constraintMaster',
        component: constraintMaster
      },
      {
        path: '/zone_master',
        name: 'Zone_master',
        component: Zone_master
      },
      {
        path: '/pickupdone',
        name: 'pickupdone',
        component: pickupdone
      },
      //shamal END
      {
        path: '/route_mapping',
        name: 'route_mapping',
        component: route_mapping,
        beforeEnter: requireAuth
      },
      {
        path: '/plan_master',
        name: 'plan_master',
        component: plan_master,
        beforeEnter: requireAuth
      },

      {
        path: '/direct_dispatch',
        name: 'direct_dispatch',
        component: direct_dispatch
      },

      {
        path: '/handover_pendency',
        name: 'hanodver_pendency',
        component: handover_pendency,
        beforeEnter: requireAuth
      },
      {
        path: '/vehicle_tracking',
        name: 'vehicle_tracking',
        component: vehicle_tracking_new,
        beforeEnter: requireAuth
      },
      {
        path: '/vehicle_tracking_new',
        name: 'vehicle_tracking_new',
        component: vehicle_tracking_new,
        beforeEnter: requireAuth
      },
      {
        path: '/testData',
        name: 'testData',
        component: testData,
        beforeEnter: requireAuth
      },
      {
        path: '/transporter_master',
        name: 'transporter_master',
        component: transporter_master,
        beforeEnter: requireAuth
      },
      {
        path: '/PDA_Management',
        name: 'PDA_Management',
        component: PDA_Management
      },
      {
        path: '/PDA_Add',
        name: 'PDA_Add',
        component: PDA_Add
      },
      {
        path: '/route_history',
        name: route_history,
        component: route_history
      },
      {
        path: '/route_configuration',
        name: route_configuration,
        component: route_configuration
      },
      {
        path: '/fcclock_Dashboard',
        name: 'fcclock_Dashboard',
        component: fcclock_Dashboard,
        beforeEnter: requireAuth
      },
      {
        path: '/payroll_report',
        name: 'payroll_report',
        component: payroll_report,
        beforeEnter: requireAuth
      },
      {
        path: '/fcclock_weeklyupload',
        name: 'fcclock_weeklyupload',
        component: fcclock_weeklyupload,
        beforeEnter: requireAuth
      },
      {
        path: '/employeerequest',
        name: 'employeerequest',
        component: employeerequest,
        beforeEnter: requireAuth
      },
      {
        path: '/fcclock_datatable/:type/:hubid/:shift/:shiftstart/:shiftend',
        name: 'fcclock_datatable',
        component: fcclock_datatable,
        beforeEnter: requireAuth
      },
      {
        path: '/fcclock_hubconfiguration_details',
        name: 'fcclock_hubconfiguration_details',
        component: fcclock_hubconfiguration_details,
        beforeEnter: requireAuth
      },
      {
        path: '/vehicle_reallocation',
        name: 'vehicle_reallocation',
        component: vehicle_reallocation
      },
      {
        path: '/tatUpload',
        name: 'tatUpload',
        component: tatUpload,
        beforeEnter: requireAuth
      },
      {
        path: '/tatreport',
        name: 'tatreport',
        component: tatreport,
        beforeEnter: requireAuth
      },
      {
        path: '/Daily_pickup_report',
        name: 'Daily_pickup_report',
        component: Daily_pickup_report,
        beforeEnter: requireAuth
      },
      {
        path: '/pdamoduleaccess/:id/',
        name: 'pdamoduleaccess',
        component: pdamoduleaccess,
        beforeEnter: requireAuth
      },
      {
        path: '/serviceable_pincode',
        name: 'serviceable_pincode',
        component: serviceable_pincode,
        beforeEnter: requireAuth
      },
      {
        path: '/approver_config',
        name: 'Approver Configuration',
        component: approver_config,
        beforeEnter: requireAuth
      },
      {
        path: '/EDD_report',
        name: 'EDD Breached Report',
        component: EDD_report,
        beforeEnter: requireAuth
      },
      {
        path: '/request_config',
        name: 'requestConfig',
        component: request_config
      },
      {
        path: '/adhocpendingrequest',
        name: 'Adhoc Requests',
        component: raisedRequest,
        beforeEnter: requireAuth
      },
      {
        path: '/adhocvehiclefreight/:id',
        name: 'AdhocVehicleFreight',
        component: adhocVehicleFreight,
        beforeEnter: requireAuth
      },
      {
        path: '/adhocvehiclefreightapproval/:id',
        name: 'AdhocVehicleFreightApproval',
        component: adhocVehicleFreightApproval,
        beforeEnter: requireAuth
      },
      {
        path: '/addNewVehicleDetails/:id',
        name: 'addNewVehicleDetails',
        component: addNewVehicleDetails,
        beforeEnter: requireAuth
      },
       {
        path: '/availableVehicleList',
        name: 'availableVehicleList',
        component: availableVehicleList,
        beforeEnter: requireAuth
      },
      {
        path: '/notificationStatus',
        name: 'notificationStatus',
        component: notificationStatus
      },
      {
        path: '/audit_status_details',
        name: 'audit_status_details',
        component: AuditStatusDetails
      },
      {
        path: '/audit_status_dashboard',
        name: 'audit_status_dashboard',
        component: AuditStatusDashboard
      },
      {
        path: '/fcclockregularization',
        name: 'fcclockregularization',
        component: FcClockRegularization,
      },
      {
        path: '/fcclockemployeerequests',
        name: 'fcclockemployeerequests',
        component: fcClockEmployeeRequests,
      },
      {
        path: '/newPlanUploadNew',
        name: 'newplanuploadNew',
        component: newplanuploadNew,
        beforeEnter: requireAuth
      },
       {
      path: '/apkUrlUpload',
      name: 'apk_url_upload',
      component: apkUrlUpload,
    },
    {
        path: '/PickDoneToOFD',
        name: 'PickDoneToOFD',
        component: PickDoneToOFD,
        beforeEnter: requireAuth
    },

    {
        path: '/operational_dashboard',
        name: 'operational_dashboard',
        component: operational_dashboard,
        beforeEnter:requireAuth
    },
    {
        path: '/vehiclemovement',
        name: 'vehiclemovement',
        component: vehiclemovement,
        beforeEnter:requireAuth
    },
    {
        path: '/shipmentsdispatched',
        name: 'shipmentsdispatched',
        component: shipmentsdispatched,
        beforeEnter: requireAuth
    },
    { 
        path: '/srid',
        name: 'srid',
        component: srid,
        beforeEnter: requireAuth
    }
    
    ]
  }, {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/shipment_tracking',
    name: 'shipment_tracking',
    component: shipment_tracking
  }]
})


router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  // routerPush(router.)
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {

  NProgress.done()
})

export default router
function requireAuth(to, from, next) {
  var chkauth = auth.loggedIn()
  if (chkauth) {
    // alert("inn");
    console.log(chkauth);
    next({
      path: '/login'
    })
  } else {
    next()
  }
}

// function requireAuthCod(to, from, next) {
//     const axios = require('axios')
//     //console.log('url:',CONSTANTS.API_URL);
//     axios.post(`${CONSTANTS.API_URL}/ValidateSystemUserLogin`,{sysemailid:"p2pcod@xpressbees.com",syspassword:"$p2pcod$"})
//     .then(response => {
//         if(response.data.returnmsg === 'successful'){
//             let userData = response.data.returnvalue[0];
//             // console.log('data: ', userData);
//             localStorage.setItem('userData', JSON.stringify(userData))
//             localStorage.setItem('Coduser', "codvaliduser")
//             var d1 = new Date()
//             localStorage.setItem('activeTime', d1.getMinutes())
//             Vue.http.headers.common['x-access-token']  = userData['token'];
//             next()
//         }
//     })
// }
